import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, IonicPage, ItemSliding, NavController, NavParams, ToastController } from 'ionic-angular';
import { RoleProvider } from './../../../providers/role/role';
import { ConfigurationRoleAddPage } from './configuration-role-add/configuration-role-add';
import { ConfigurationRoleEditPage } from './configuration-role-edit/configuration-role-edit';

@IonicPage()
@Component({
  selector: 'page-configuration-role',
  templateUrl: 'configuration-role.html',
})
export class ConfigurationRolePage {
  roles: any = [];
  reqRoles: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private rolePrvdr: RoleProvider,
    private toastCtrl: ToastController,
    private translateSvc: TranslateService,
    private alertCtrl: AlertController
  ) {}

  ionViewDidEnter() {
    this.loadRole();
  }

  loadRole() {
    this.reqRoles = this.rolePrvdr.get().subscribe(
      (res: any) => {
        if (res.success === true) {
          this.roles = res.data;
        } else {
          this.showToast('ERROR: ' + res.message);
        }
      },
      (error) => {
        this.showToast('ERROR: ' + error.message);
      }
    );
  }

  onAdd() {
    this.navCtrl.push(ConfigurationRoleAddPage);
  }

  onEdit(data) {
    this.navCtrl.push(ConfigurationRoleEditPage, data);
  }

  askDelete(sliding: ItemSliding, data) {
    let alert = this.alertCtrl.create({
      title: this.translateSvc.instant('Confirm Delete'),
      message: this.translateSvc.instant('Are you sure want to delete role') + data.name + '?',
      buttons: [
        {
          text: this.translateSvc.instant('Cancel'),
          handler: () => {
            sliding.close();
          },
        },
        {
          text: this.translateSvc.instant('Confirm'),
          handler: () => {
            sliding.close();
            this.onDelete(data._id);
          },
        },
      ],
    });

    alert.present();
  }

  onDelete(id: string) {
    this.rolePrvdr.delete(id).subscribe(
      (res: any) => {
        if (res.success === true) {
          this.loadRole();
        } else {
          this.showToast('ERROR: ' + this.translateSvc.instant('Failed delete role.'));
        }
      },
      (error) => {
        this.showToast('ERROR: ' + error.message);
      }
    );
  }

  private showToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  ionViewDidLeave() {
    this.reqRoles.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-role/configuration-role.ts